import { useState } from "react";
import { useNavigate } from "react-router";
import { Layout } from "../../UI/Layout/Layout.tsx";
import { NavBar } from "../../UI/Layout/NavBar.tsx";
import { Footer } from "../../UI/Layout/Footer.tsx";
import { AdminMainContainer } from "../../UI/Admin/AdminMainContainer.tsx";
import { AllBonificoOrdersScreenPath } from "./AllBonificoOrdersScreen.tsx";
import { BonificoOrderForm } from "./BonificoOrderForm.tsx";
import { B2BBonificoOrderForm } from "./B2BBonificoOrderForm.tsx";
import { ExternalSettlementForm } from "./ExternalSettlementForm.tsx";
import { OrderKindTabs } from "./OrderKindTabs.tsx";

type OrderKind = "classic" | "b2b" | "externalSettlement";

const ORDER_KIND_LABELS: Record<OrderKind, string> = {
  classic: "Ordine classico",
  b2b: "Ordine B2B",
  externalSettlement: "Saldo ordine esterno",
};

export const CreateBonificoOrderScreenPath = "/admin/bonifico/create";

export function CreateBonificoOrderScreen() {
  const navigate = useNavigate();
  const [orderKind, setOrderKind] = useState<OrderKind>("classic");
  const [isHistorical, setIsHistorical] = useState(false);
  const mode = isHistorical ? "historical" : "create";
  const toOrders = () => navigate(AllBonificoOrdersScreenPath);

  return (
    <Layout>
      <AdminMainContainer>
        <NavBar showAdminSideBarHandle />
        <div className="flex-1 p-4 flex flex-col gap-6 max-w-3xl mx-auto w-full">
          <div className="flex items-center gap-4">
            <button
              onClick={toOrders}
              className="text-sm text-blue-600 hover:underline"
            >
              ← Torna agli ordini
            </button>
            <h1 className="font-bold text-2xl">Nuovo ordine bonifico</h1>
          </div>

          <OrderKindTabs
            labels={ORDER_KIND_LABELS}
            value={orderKind}
            onChange={setOrderKind}
          />

          {orderKind === "classic" && (
            <>
              <label className="flex items-center gap-3 cursor-pointer bg-white rounded-xl border border-gray-200 p-4">
                <input
                  type="checkbox"
                  checked={isHistorical}
                  onChange={(e) => setIsHistorical(e.target.checked)}
                  className="w-4 h-4 accent-primary"
                />
                <span className="text-sm font-medium text-gray-700">
                  Ordine storico: già gestito, da inserire solo su BigQuery
                </span>
              </label>

              <BonificoOrderForm
                key={mode}
                mode={mode}
                onSaved={toOrders}
                onCancel={toOrders}
              />
            </>
          )}
          {orderKind === "b2b" && (
            <B2BBonificoOrderForm onSaved={toOrders} onCancel={toOrders} />
          )}
          {orderKind === "externalSettlement" && (
            <ExternalSettlementForm onSaved={toOrders} onCancel={toOrders} />
          )}
        </div>
      </AdminMainContainer>
      <Footer />
    </Layout>
  );
}
